import AuthService from "./AuthService";
import { SystemService } from './SystemService';
import { v4 } from 'uuid';
import { saveAs } from 'file-saver';
import { MachinesService } from "./MachinesService";

export class DionysosService {
    systemService = null;
    api = null;
    authService = null;
    machinesService = null;
    
    constructor(){
        this.systemService = new SystemService();
        this.authService = new AuthService();
        this.machinesService = new MachinesService();
        this.api = this.systemService.getApiAccess();
    }

    getVolumes(search = '', status, page = 1, perPage = 10){
        let user = this.authService.getUser();
        let config = this.authService.getConfig();
        let sessionid = this.authService.getSessionId();
        if(!user){
            throw "Δεν είστε συνδεδεμένος";
        }
        if(!config){
            throw "Δεν έχετε επιλέξει Α/Χ";
        }
        let volumesPromise = new Promise((resolve, reject) => {
            this.api.post('dionysos/search', {search: search || '', status, page: Number(page) || 1, perPage: Number(perPage) || 10}, { headers: { authorization: sessionid } }).then(r => {
                resolve(r.data);
            }).catch(e => {
                reject(e.message);
            });
        });
        return volumesPromise;
    }

    createVolume(volume){
        let addVolumePromise = new Promise((resolve, reject) => {
            let sessionid = this.authService.getSessionId();
            let config = this.authService.getConfig();
            volume.wh = config.whCode;
            volume.uuid = v4();
            this.api.post('dionysos/create', volume, {
                headers: {
                    authorization: sessionid
                }
            }).then(r => {
                resolve(r.data);
            }).catch(e => {
                reject('H δημιουργία του όγκου απέτυχε, παρακαλώ προσπαθήστε ξανά');
            })
        });
        return addVolumePromise;
    }

    updateVolume(volume){
        let updateVolumePromise = new Promise((resolve, reject) => {
            let sessionid = this.authService.getSessionId();
            let config = this.authService.getConfig();
            
            this.api.post('dionysos/update', volume, {
                headers: {
                    authorization: sessionid
                }
            }).then(r => {
                resolve(r.data);
            }).catch(e => {
                reject('H ενημέρωση του όγκου απέτυχε, παρακαλώ προσπαθήστε ξανά');
            })
        });
        return updateVolumePromise;
    }

    addMeasurement(measurement){
        if(!measurement.width){
            throw "Το πλάτος είναι υποχρεωτικό";
        }
        if(!measurement.depth){
            throw "Tο ύψος είναι υποχρεωτικό";
        }
        if(!measurement.length){
            throw "Το μήκος είναι υποχρεωτικό";
        }
        let measurePromise = new Promise((resolve, reject) => {
            let sessionid = this.authService.getSessionId();
            this.api.post('dionysos/measure', measurement, {
                headers: {
                    authorization: sessionid
                }
            }).then(r => {
                if(r.error){
                    reject(r);
                }
                else{
                    resolve(r.data);
                }
            }).catch(e => reject(e.message));
        });
        return measurePromise;
    }

    assess(assessment){
        console.log(assessment);
        if(!assessment.assessment){
            throw "Πρέπει να επιλέξετε βαθμό αξιολόγησης";
        }
        if(!assessment.color){
            throw "Πρέπει να επιλέξετε χρωματική κατηγορία";
        }
        if(!assessment.problems){
            throw "Πρέπει να επιλέξετε τύπους Ελαττωμάτων ή 'Χωρίς Ελαττώματα'";
        }
        let sessionid = this.authService.getSessionId();
        let assessPromise = new Promise((resolve, reject) => {
            this.api.post('dionysos/assess', assessment, {
                headers: {
                    authorization: sessionid
                }
            }).then(r => {
                if(r.error){
                    reject(r);
                }
                else{
                    resolve(r.data);
                }
            }).catch(e => {
                reject(e.message);
            });
        });
        return assessPromise;
    }

    syncToErp(v) {
        let config = this.authService.getConfig();
        let sessionid = this.authService.getSessionId();
        v.itemCode = this.getVolumeItem(v);
        let SyncPromise = new Promise((resolve, reject) => {
            this.api.post('dionysos/syncToErp', v, {
                headers: {
                    authorization: sessionid
                }
            }).then(r => resolve(r)).catch(e => reject(e.message));
        });
        return SyncPromise;
    }

    weighVolume(weighing){
        let sessionid = this.authService.getSessionId();
        let weighPromise = new Promise((resolve, reject) => {
            this.api.post('dionysos/weigh', weighing, {
                headers: {
                    authorization: sessionid
                }
            }).then(r => resolve(r.data)).catch(e => reject(e.message));
        });
        return weighPromise;
    }

    exportVolumesToExcel(){
        let config = this.authService.getConfig();
        let sessionid = this.authService.getSessionId();
        console.log('exporting');
        this.api.get(`dionysos/export`, {responseType: 'blob', headers: {authorization: sessionid}}).then(response => {
            console.log('received');
            console.log(response.data);
            const blob = new Blob([response.data], {
                type: response.headers['content-type'],
            });
            saveAs(blob, 'Blocks.xlsx');
        });
    }
    
    completeVolume(volume){
        let sessionid = this.authService.getSessionId();
        let completePromise = new Promise((resolve, reject) => {
            this.api.post('dionysos/complete', volume, {
                headers: {
                    authorization: sessionid
                }
            }).then(r => resolve(r.data)).catch(e => reject(e.message));
        });
        return completePromise;
    }

    getStock(){
        let sessionid = this.authService.getSessionId();
        let stockPromise = new Promise((resolve, reject) => {
            this.api.get('dionysos/stock', {
                headers: {
                    authorization: sessionid
                }
            }).then(r => resolve(r.data)).catch(e => reject(e.message));
        });
        return stockPromise;
    }

    getVolumeItem(v) {
        return v.assessments[0]?.assessment === 'T' ? '0000002' : '0000001';
    }

    getVolumeDescr(v) {
        return v.assessments[0]?.assessment === 'T' ? 'ΞΩΦΑΡΙ ΔΙΟΝΥΣΟΥ' : 'ΟΓΚΟΣ ΜΑΡΜΑΡΟΥ ΔΙΟΝΥΣΟΥ';
    }

    getAllVolumes(self, dateFrom, dateTo){
        let sessionid = this.authService.getSessionId();
        let params = {};
        if(self){
            params.self = self;
        }
        if(dateFrom){
            params.dateFrom = dateFrom;
        }
        if(dateTo){
            params.dateTo = dateTo;
        }
        let stockPromise = new Promise((resolve, reject) => {
            this.api.post('dionysos/allVolumes', params, {
                headers: {
                    authorization: sessionid
                }
            }).then(r => resolve(r.data)).catch(e => reject(e.message));
        });
        return stockPromise;
    }

    async deleteVolume(volumeId){
        let sessionid = this.authService.getSessionId();
        let deletePromise = new Promise((resolve, reject) => {
            this.api.delete(`dionysos/volume/${volumeId}`, {
                headers: {
                    authorization: sessionid
                }
            }).then(r => resolve(r.data)).catch(e => reject(e.message));
        });
        return deletePromise;
    }

    async updateVolume(v){
        let sessionid = this.authService.getSessionId();
        let updatePromise = new Promise((resolve, reject) => {
            this.api.put(`dionysos/volume/${v.volumeId}`, v, {
                headers: {
                    authorization: sessionid
                }
            }).then(r => resolve(r.data)).catch(e => reject(e.message));
        });
        return updatePromise;
    }

    getMachines(wh){
        let config = this.authService.getConfig();
        const warehouse = wh !== undefined ? wh : config?.whCode;
        return this.machinesService.getMachines(warehouse);
    }

}